
let url = '/manage_api' // 测试/生产
// let url = '/manage_api_sz' // 压测环境
// let url = '/spark_manage'
let h5lLineComurl = '/h5/#/linecompetitionEntry'
let wsUrl = window.location.host + '/web_api'
let preffix = '/manage_api_sz/upload/selVedioByName'
let preffixFile = '/file/'
let preffixVideo = '/vedio/'
let preffixImg = '/image/';
let global = {};
let dimage = window.location.protocol + '//' + window.location.host;
// if (process.env.NODE_ENV === 'production') {
//   if (process.env.type === 'testing') {
//     url = 'http://192.168.0.70/spark_manage'
//     h5lLineComurl = 'http://192.168.0.70/manager/h5/#/linecompetitionEntry';
//     preffix = 'http://192.168.0.70/spark_manage/upload/selVedioByName';
//     preffixVideo = 'http://192.168.0.70/vedio/';
//     preffixImg = 'http://192.168.0.70/image/';
//     preffixFile = 'http://192.168.0.70/file/';
//     wsUrl = '192.168.0.70:8081/spark_web'
//     dimage = 'http://192.168.0.70';
//   } else if (process.env.type === 'pressure') {
//     url = 'https://yf.zpspark.com//manage_api'
//     h5lLineComurl = 'https://yf.zpspark.com/h5/#/linecompetitionEntry';
//     preffix = 'https://yf.zpspark.com//manage_api/upload/selVedioByName';
//     preffixVideo = 'https://yf.zpspark.com//vedio/';
//     preffixImg = 'https://yf.zpspark.com//image/';
//     preffixFile = 'https://yf.zpspark.com//file/';
//     wsUrl = 'yf.zpspark.com//web_api'
//     dimage = 'https://yf.zpspark.com';
//   } else {
//     url = 'https://www.zpspark.com/manage_api'
//     h5lLineComurl = 'https://www.zpspark.com/h5/#/linecompetitionEntry';
//     preffix = 'https://www.zpspark.com/manage_api/upload/selVedioByName';
//     preffixFile = 'https://www.zpspark.com/file/'
//     preffixVideo = 'https://www.zpspark.com/vedio/';
//     preffixImg = 'https://www.zpspark.com/image/';
//     wsUrl = 'www.zpspark.com/web_api'
//     dimage = 'https://www.zpspark.com';
//   }
// } else {
//   // url = 'https://www.zpspark.com/manage_api'
//   // preffix = 'https://www.zpspark.com/manage_api/upload/selVedioByName';
//   // preffixFile = 'https://www.zpspark.com/file/'
//   // preffixVideo = 'https://www.zpspark.com/vedio/';
//   // preffixImg = 'https://www.zpspark.com/image/';
//   // url = 'https://yf.zpspark.com//manage_api'
//   url = 'http://192.168.0.158:8080/spark_manage'
//   h5lLineComurl = 'http://localhost:8013/#/linecompetitionEntry';
//   // wsUrl = '192.168.0.158:9800/spark_web'
//   wsUrl = '192.168.0.70:8081/spark_web'
//   preffix = 'http://192.168.0.70/spark_manage/upload/selVedioByName';
//   preffixFile = 'http://192.168.0.70/file/'
//   preffixVideo = 'http://192.168.0.70/vedio/';
//   preffixImg = 'http://192.168.0.70/image/';
//   dimage = 'http://192.168.0.70';
// }
// let host = window.location.host.split(':')[0];
// console.log(host, '--------------')
export { url, h5lLineComurl, wsUrl, preffix, preffixFile, preffixVideo, preffixImg, global, dimage };



// WEBPACK FOOTER //
// ./src/components/common/common.js